// Actions types
export const GET_ADP_FILE = 'searchAdpFile';
export const GET_ADP_CUSTOMERS = 'getAdpCustomers';
export const DOWNLOAD_ADP_FILES = 'downloadAdpFile';

// Mutations types
export const SET_ADP_FILES_ERRORS = 'setAdpFilesErrors';
export const SET_ADP_FILES_LOADING = 'setAdpFilesLoading';
export const SET_ADP_FILES = 'setAdpFiles';
export const APD_CUSTOMERS = 'setAdpCustomerList';

// Getters types
export const ADP_FILES_ERRORS = 'adpFilesErrors';
export const ADP_FILES_LOADING = 'adpFilesLoading';
export const ADP_FILES_LIST = 'adpFilesList';
export const SET_ADP_CUSTOMERS = 'setAdpCustomers';
export const SET_ADP_CUSTOMERS_ERROR = 'setAdpCustomersError';
